import { FilterOperators } from '@/enums/filter-operators'

export type TFilter = {
    column: string | null
    operator: FilterOperators | null
    value: string | number | Date[]
    hide?: boolean
}


export type Sorter = {
    column: string
    order: 'asc' | 'desc'
}


export type Query = {
    filters?: TFilter[]
    page?: number
    pageSize?: number
    sorter?: Sorter
    params?: Record<string, any>
}

export namespace Query {
    export function build(query: Query | null  | undefined): string {
        if (!query)
            return ""

        const params = new URLSearchParams()

        if (query.page != null)
            params.set('page', String(query.page))

        if (query.pageSize != null)
            params.set('pageSize', String(query.pageSize))

        if (query.filters?.length)
            params.set('filters', JSON.stringify(query.filters))

        if (query.sorter)
            params.set('sorter', JSON.stringify(query.sorter))

        if (query.params) {
            Object.entries(query.params).forEach(([key, value]) => {
                params.set(key, JSON.stringify(value))
            })
        }

        return params.toString()
    }
}
